<template>
  <div
    class="drag-and-drop-container"
  >
    <div
      class="answer-wrapper"
      :class="{ answered: answered }"
    >
      <div
        class="answer-choices"
      >
        <div class="column-header">
          {{ flashcard.matrixGridColumnHeaders[0] }}
        </div>
        <div
          v-for="(answerChoice) in answerChoices"
          :key="answerChoice.id"
          class="answer-box"
          :tabindex="answered ? -1 : 0"
          @click="selectAnswer(answerChoice)"
          @keydown.space.self="selectAnswer(answerChoice)"
          @keydown.enter.self="selectAnswer(answerChoice)"
        >
          <div class="answer-item">
            <correctness-box
              v-if="answered"
              :correct="answerChoice.correct"
            >
            </correctness-box>
            <span>{{ answerChoice.text }}</span>
          </div>
        </div>
      </div>
      <div
        class="answer-choices"
      >
        <div class="column-header">
          {{ flashcard.matrixGridColumnHeaders[1] }}
        </div>
        <div
          v-for="(selectedAnswer) in selectedAnswers"
          :key="selectedAnswer.id"
          class="answer-box selected"
          :tabindex="answered ? -1 : 0"
          @click="deselectAnswer(selectedAnswer)"
          @keydown.space.self="deselectAnswer(selectedAnswer)"
          @keydown.enter.self="deselectAnswer(selectedAnswer)"
        >
          <div class="answer-item">
            <correctness-box
              v-if="answered"
              :correct="selectedAnswer.correct"
              :selected="true"
            >
            </correctness-box>
            <span>{{ selectedAnswer.text }}</span>
          </div>
        </div>
        <div
          v-if="selectedAnswers.length === 0"
          class="answer-box answer-target"
        >
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CorrectnessBox from '@components/singletons/CorrectnessBox';

export default {
  components: { CorrectnessBox },
  props: {
    answered: {
      type: Boolean,
    },
    answerIds: {
      type: Array,
    },
    correct: {
      type: Boolean,
    },
    flashcard: {
      type: Object,
    },
    flashcardState: {
      type: Object,
      default: () => ({}),
    },
    lockedRationales: {
      type: Boolean,
    },
    rawAnswerData: {
      type: Object,
    },
    metadata: {
      type: Object,
    },
  },
  computed: {
    answerChoices() {
      return this.flashcard.answers.filter(
        answer => !this.answerIds.includes(answer.id)
      );
    },
    selectedAnswers() {
      return this.answerIds.map(id => this.flashcard.answers.find(a => a.id === id));
    },
  },
  methods: {
    deselectAnswer(answer) {
      if (this.answered) {
        return;
      }
      this.$emit('set-answer-ids', this.answerIds.filter(id => id !== answer.id));
    },
    selectAnswer(answer) {
      if (this.answered) {
        return;
      }
      this.$emit('set-answer-ids', [...this.answerIds, answer.id]);
    },
  },
};
</script>

<style lang='scss' scoped>
.drag-and-drop-container {
  display: flex;
  flex-direction: column;
  width: 608px;
  margin-bottom: 3rem;

  .answer-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    scroll-snap-type: x mandatory;
    scroll-snap-align: center;
    overflow-x: auto;
    gap: 1rem;
    row-gap: 3rem;
    width: 100%;
    margin-bottom: 1rem;

    &::-webkit-scrollbar {
        display: none;
    }

    .answer-choices {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: 0.5rem;
      scroll-snap-align: center;
      scroll-snap-stop: always;

      .answer-box {
        border: 1px solid #E9E9E9;
        padding: 1.25rem 1rem;
        border-radius: 2px;
        cursor: pointer;

        &.answer-target {
          background: #E9E9E9;
          border: 1px dashed #C4C4C4;
        }

        &:hover {
          background: rgba(0, 216, 248, 0.1);
          border: 1px solid rgba(0, 216, 248, 0.2);
          box-shadow: 0px 2px 8px rgba(0, 216, 248, 0.08);
        }

        &.answer-target:hover {
          background: #E9E9E9;
          border: 1px dashed #C4C4C4;
        }

        &.selected {
          background: rgba(0, 216, 248, 0.1);
          border: 1px solid rgba(0, 216, 248, 0.2);

          &:hover {
            background: rgba(0, 216, 248, 0.2);
            border: 1px solid rgba(0, 216, 248, 0.4);
            box-shadow: 0px 1px 6px rgba(0, 216, 248, 0.1);
          }
        }
        .answer-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;

          .answer-text {
            margin-right: 0.5rem;
          }
          .answer-icon {
            margin-left: 0.5rem;
          }
        }
      }
    }

    &.answered {
      .answer-box {
        cursor: default;

        &:hover {
          background: inherit;
          border: 1px solid #E9E9E9;
          box-shadow: none;
        }

        &.selected {

          &:hover {
            background: rgba(0, 216, 248, 0.1);
            border: 1px solid rgba(0, 216, 248, 0.2);
            box-shadow: none;
          }
        }
      }
    }
  }
}


// when the screen width is less than 568px shift
@media screen and (max-width: 568px) {
  .drag-and-drop-container {
    width: 100%;
    .answer-wrapper {
      .answer-choices {
        width: 247px;
      }
    }
  }
}

.column-header {
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 0.75rem;
}

</style>
